import React from "react";
import Button from "../../../independent/Button";
import useCustomerCodeInput from "../../hooks/useCustomerCodeInput";


const CustomerCodeInput = ({closeModal, closeSubModal, subModalMount, handleAddNewHistory}) => {

  const {
    customerId,
    userType,
    initialValue,
    codeInputRefs,
    noCustomerCode,
    onInputHandler,
    keyDownHandler,
    setNoCustomerCode,
    getEntireCodeFromInput
  } = useCustomerCodeInput();


  return (
    <div>
      <div className={"modal-header"}>
        <h2>Enter Customer Code</h2>
        <button type="button" className="modal-close" onClick={closeSubModal}>
          close
        </button>
      </div>
      <div className={"modal-body"}>
        <div className={"save-load"}>
          <div className={"form-group code-input"} id={"EnterCode"}>
            <label>Enter Code</label>
            <div className={"form"}>
              {
                initialValue.map((item, index) => {
                  const value = userType === 'CONFIGURATION_USER' && customerId ?
                    customerId[index] || '' : '';

                  return (
                    <input
                      key={index}
                      ref={codeInputRefs.current[index]}
                      type="text"
                      data-box
                      defaultValue={value}
                      maxLength={1}
                      disabled={noCustomerCode || userType === 'CONFIGURATION_USER'}
                      onKeyDown={(e) => keyDownHandler(e, index)}
                      onInput={(e) => onInputHandler(e, index)}
                    />
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
      <div className={"modal-footer"}>
        <div className={"customer-code-footer"}>
          {
            userType === "COMMON_USER" && (
              <div className={"create-customer-code"}>
                <label>
                  <input
                    type={"checkbox"}
                    checked={noCustomerCode}
                    onChange={() => setNoCustomerCode(!noCustomerCode)}
                  />
                  Generate new customer ID to save design.
                </label>
              </div>
            )
          }
          <div>
            <Button name={"SAVE"}
                    block={true}
                    onClick={() => handleAddNewHistory(noCustomerCode, getEntireCodeFromInput(), subModalMount, closeModal, closeSubModal)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerCodeInput;
